'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

exports.isAction = isAction;

var _isPlainObject = require('is-plain-object');

var _isPlainObject2 = _interopRequireDefault(_isPlainObject);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function isAction(action) {
    var propsValid = Object.keys(action || false).every(isValidProp);
    if (!propsValid) {
        return false;
    }
    var type = action.type,
        error = action.error,
        payload = action.payload,
        meta = action.meta;

    if (typeof type !== 'string' && (typeof type === 'undefined' ? 'undefined' : _typeof(type)) === 'symbol') {
        return false;
    }
    if (typeof error !== 'boolean' && 'error' in action) {
        return false;
    }
    if (!(0, _isPlainObject2.default)(payload) && !(error === true && payload instanceof Error)) {
        return false;
    }
    if (typeof meta !== 'undefined' && !(0, _isPlainObject2.default)(meta)) {
        return false;
    }
    return true;
}
function isValidProp(name) {
    return ['type', 'error', 'payload', 'meta'].includes(name);
}
//# sourceMappingURL=isAction.js.map


// WEBPACK FOOTER //
// ./node_modules/@zaibot/fsa/es5/isAction.js